import { render, staticRenderFns } from "./RegisterGroup.vue?vue&type=template&id=07c73592&scoped=true&"
import script from "./RegisterGroup.vue?vue&type=script&lang=js&"
export * from "./RegisterGroup.vue?vue&type=script&lang=js&"
import style0 from "./RegisterGroup.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegisterGroup.vue?vue&type=style&index=1&id=07c73592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c73592",
  null
  
)

export default component.exports